import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import LoginButton from './LoginButton';
import { AuthUser } from '../services/authService';

interface AppLayoutProps {
  children: ReactNode;
  user: AuthUser | null;
  isAuthenticated: boolean;
  isAuthLoading: boolean;
  onLogin: () => void;
  onLogout: () => void;
}

export default function AppLayout({
  children,
  user,
  isAuthenticated,
  isAuthLoading,
  onLogin,
  onLogout,
}: AppLayoutProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar position="sticky" elevation={0}>
        <Toolbar>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              flexGrow: 1,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 36,
                height: 36,
                borderRadius: '50%',
                bgcolor: 'rgba(255,255,255,0.15)',
                backdropFilter: 'blur(4px)',
              }}
            >
              <RestaurantIcon sx={{ fontSize: 20 }} />
            </Box>
            <Typography
              variant="h6"
              component="h1"
              sx={{
                background: 'linear-gradient(90deg, #ffffff 0%, #c8e6c9 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Lunch Finder
            </Typography>
          </Box>
          <LoginButton
            user={user}
            isAuthenticated={isAuthenticated}
            isLoading={isAuthLoading}
            onLogin={onLogin}
            onLogout={onLogout}
          />
        </Toolbar>
      </AppBar>
      <Container maxWidth="xl" sx={{ py: 2.5, flex: 1 }}>
        {children}
      </Container>
      <Box
        component="footer"
        sx={{
          py: 1,
          px: 2,
          textAlign: 'right',
          opacity: 0.4,
          fontSize: '0.7rem',
          color: 'text.secondary',
        }}
      >
        {import.meta.env.VITE_COMMIT_HASH
          ? `v${import.meta.env.VITE_COMMIT_HASH.slice(0, 7)}`
          : 'dev'}
      </Box>
    </Box>
  );
}
